/* Oxygen · página de produto (sections/ox-product-main.liquid)
   1. Galeria: contador "1 / 4", setas e miniaturas.
   2. Prazo pelo CEP: região pelo prefixo + dias úteis da política, mostrado como datas. Sem API.
   3. Barra fixa de compra (celular): aparece quando nenhum botão de compra está na tela. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Galeria ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-ox-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var counter = root.querySelector('[data-ox-count]');
    var prev = root.querySelector('[data-ox-prev]');
    var next = root.querySelector('[data-ox-next]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ox-thumb]'));
    var current = 0;

    function show(i) {
      current = i;
      if (counter) counter.textContent = i + 1 + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    function go(i) {
      var target = slides[Math.max(0, Math.min(slides.length - 1, i))];
      if (!target) return;
      var padding = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      track.scrollTo({ left: target.offsetLeft - padding, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if ('IntersectionObserver' in window && slides.length > 1) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            /* isIntersecting vale até pra pontinha da próxima foto; conta só a que está quase inteira */
            if (e.intersectionRatio >= 0.6) show(slides.indexOf(e.target));
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (s) { io.observe(s); });
    }

    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.oxThumb, 10)); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  }

  /* ---------- 2. Prazo pelo CEP ---------- */
  var WEEKDAYS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
  var MONTHS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

  /* Faixas dos Correios pelos 5 primeiros dígitos. */
  function regionOf(cep5) {
    if (cep5 >= 1000 && cep5 <= 39999) return { name: 'Sudeste', key: 'se' };
    if (cep5 >= 40000 && cep5 <= 65999) return { name: 'Nordeste', key: 'nne' };
    if (cep5 >= 66000 && cep5 <= 69999) return { name: 'Norte', key: 'nne' };
    if (cep5 >= 76800 && cep5 <= 77999) return { name: 'Norte', key: 'nne' };
    if (cep5 >= 70000 && cep5 <= 79999) return { name: 'Centro-Oeste', key: 'sco' };
    if (cep5 >= 80000 && cep5 <= 99999) return { name: 'Sul', key: 'sco' };
    return null;
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function fmt(d) {
    return WEEKDAYS[d.getDay()] + ', ' + d.getDate() + '/' + MONTHS[d.getMonth()];
  }

  function maskCep(value) {
    var digits = value.replace(/\D/g, '').slice(0, 8);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function initCep(form) {
    var input = form.querySelector('[data-ox-cep-input]');
    var out = form.querySelector('[data-ox-cep-out]');
    if (!input || !out) return;
    var processing = parseInt(form.dataset.processing, 10) || 0;

    function range(key) {
      var parts = (form.dataset[key] || '').split('-');
      return [parseInt(parts[0], 10) || 0, parseInt(parts[1], 10) || 0];
    }

    function message(html, isError) {
      out.innerHTML = '<p class="ox-body-sm ' + (isError ? 'ox-field-msg--error' : 'ox-muted') + '">' + html + '</p>';
      input.setAttribute('aria-invalid', isError ? 'true' : 'false');
    }

    function calculate() {
      var digits = input.value.replace(/\D/g, '');
      if (digits.length !== 8) {
        message('Digite os 8 números do CEP.', true);
        return;
      }
      var region = regionOf(parseInt(digits.slice(0, 5), 10));
      if (!region) {
        message('Não achamos esse CEP. Confira os números.', true);
        return;
      }
      var r = range(region.key);
      var today = new Date();
      var first = addBusinessDays(today, processing + r[0]);
      var last = addBusinessDays(today, processing + r[1]);
      input.setAttribute('aria-invalid', 'false');
      out.innerHTML =
        '<p class="ox-pm__cep-date">Chega entre <b>' + fmt(first) + '</b> e <b>' + fmt(last) + '</b></p>' +
        '<p class="ox-body-sm ox-muted">' + region.name + ' · frete grátis. Postagem em até ' + processing +
        ' dias úteis e entrega em ' + r[0] + ' a ' + r[1] + ' dias úteis, com rastreio.</p>';
      try { localStorage.setItem('ox-cep', digits); } catch (e) {}
    }

    input.addEventListener('input', function () {
      input.value = maskCep(input.value);
      if (input.getAttribute('aria-invalid') === 'true') input.setAttribute('aria-invalid', 'false');
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      calculate();
    });

    try {
      var saved = localStorage.getItem('ox-cep');
      if (saved && saved.length === 8) {
        input.value = maskCep(saved);
        calculate();
      }
    } catch (e) {}
  }

  /* ---------- 3. Barra fixa ---------- */
  function initSticky(bar) {
    var root = document.documentElement;
    var mobile = window.matchMedia('(max-width: 989px)');
    var buttons = document.querySelectorAll('[data-ox-buy]');
    var onScreen = new Set();
    if (!('IntersectionObserver' in window) || !buttons.length) return;

    function update() {
      var show = mobile.matches && onScreen.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
      root.style.setProperty('--ox-sticky-h', show ? bar.offsetHeight + 'px' : '0px');
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) onScreen.add(e.target);
        else onScreen.delete(e.target);
      });
      update();
    });
    buttons.forEach(function (b) { io.observe(b); });
    if (mobile.addEventListener) mobile.addEventListener('change', update);
  }

  function init() {
    document.querySelectorAll('[data-ox-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-ox-cep]').forEach(initCep);
    var bar = document.querySelector('[data-ox-sticky]');
    if (bar) initSticky(bar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* No editor do tema a seção recarrega sozinha. */
  document.addEventListener('shopify:section:load', init);
})();
